import React from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {withRouter} from 'react-router';

import {withConfig, withI18n} from 'spa/Components/Context';
import {cn} from 'spa/css';

import CartWithCountButton from '../../Pages/BookingNext/Components/CartWithCountButton';

@withRouter
@inject(({
  store: {
    basketNew,
    tracker,
  },
}) => ({
  basketNew,
  tracker,
}))
@observer
@withConfig
@withI18n
class HeaderBasketSectionWrapper extends React.Component {
  static propTypes = {
    basketNew: PropTypes.shape({
      getBasketSummary: PropTypes.func.isRequired,
    }).isRequired,
    userLoggedIn: PropTypes.bool,
    hasBorder: PropTypes.bool,
  };

  componentDidMount() {
    const { basketNew } = this.props;

    basketNew.getBasketSummary()
      .catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
      });
  }

  render() {
    const {
      userLoggedIn,
      hasBorder,
    } = this.props;

    return (
      <div className={cn(
        'site-header__basket-button-container',
        'site-header__basket-button-container-next',
        userLoggedIn && 'site-header__basket-button-container-next--signed-in',
        hasBorder && 'site-header__basket-button-container--has-border',
      )}>
        <CartWithCountButton />
      </div>
    );
  }
}

export default HeaderBasketSectionWrapper;



// WEBPACK FOOTER //
// ./spa/Components/HeaderBasketSectionWrapper/HeaderBasketSectionWrapper.jsx